import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { GlobalService } from './global.service';
import { Signatario } from '../models/signatario';

@Injectable({
  providedIn: 'root'
})
export class SignatarioService {

  constructor(private globalService: GlobalService, private http: HttpClient) {
  }

  consultar(id: number) {
    return this.http.get<Signatario>(globals.apiUrl + '/api/Signatario/Buscar', {
      params: new HttpParams()
        .set('id', id.toString())
    });
  }

  consultarListaEmpresaAtual() {
    return this.http.get<Signatario[]>(globals.apiUrl + '/api/Signatario/ListarPorEmpresaAtual');
  }

  consultarListaContato(idGIContato: number) {
    return this.http.get<Signatario[]>(globals.apiUrl + '/api/Signatario/ListarPorContato', {
      params: new HttpParams()
        .set('idGIContato', idGIContato.toString())
    });
  }

  salvar(sig: Signatario) {
    return this.http.post(globals.apiUrl + '/api/Signatario/Salvar', sig);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/Signatario/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  verificaCPF(cpf) {
    return this.http.get<any>(globals.apiUrl + '/api/Signatario/VerificaCPF',
      { params: new HttpParams().set('cpf', cpf) });
  }
}
